import React, { useState, memo, useEffect } from 'react'
import { iconwrapper } from '../../../../../../config/commonfunctions'
import { ADD_ICON, CROSS_ICON } from '../../../../../../config/svgicons'
import { describe_dom } from '../Commonelements/Commonelements'
import Success from './components/Success'
import './Glmodal.css'

const CROSSICON_CSS = { width: 20, height: 20, display: 'flex', placeContent: 'center' }
const ADDICON_CSS = { width: 24, height: 24, display: 'flex', placeContent: 'center' }

function Addrelacontent(props) {
    const { addrelasavingstate } = props
    const [relaholder, setRelaholder] = useState([])
    const [addrelamodalguestrelas, setAddrelamodalguestrelas] = useState([])
    const [once, setOnce] = useState(false)

    useEffect(() => {
        if (props && !once) {
            setAddrelamodalguestrelas(props.addrelamodalguestrelas)
            setOnce(true)
        }
    }, [props])

    const addrela = () => {
        var temp = addrelamodalguestrelas.slice()
        if (relaholder.length > 0) {
            if (temp.indexOf(relaholder) < 0) temp.push(relaholder)
            setAddrelamodalguestrelas(temp)
        }
        setRelaholder('')
    }

    const delrela = (index) => {
        var temp = addrelamodalguestrelas.slice()
        temp.splice(index, 1)
        setAddrelamodalguestrelas(temp)
    }

    // <div className='Rsvpexplorer_portal'>
    //     {title_dom}
    //     {(savingstate === 'IDLE' || savingstate === 'SAVING' || savingstate === 'FAILURE')
    //         ? <div className='Rsvpexplorer_portalcontent'>
    //             {qntype_dom}
    //             {colname_dom}
    //             {whocanviewqn_dom}
    //             {qntypecontent_dom}
    //             {saving_btn}
    //         </div>
    //         : null}
    //     {success_dom}
    // </div>

    const general_dom = <div className='Rsvpexplorer_portalcontent'>
        
        {describe_dom(
            {
                'Invitationguestlist': 'Create and assign a relationship tag to your guest for easier searching. This will not be visible to guests.',
                'Searchchartedit': 'Create a new relationship tag and assign it to the guest for easier reference.',
            }[props.from],
            { padding: '5px 10px 0px', marginBottom: 20 }
        )}
        
        <div style={{ display: 'flex', flexDirection: 'row', padding: '0px 10px' }}>
            <input className='Rsvpexplorer_input' style={{ marginRight: 5, marginBottom: 10 }} value={relaholder} onChange={(e) => setRelaholder(e.target.value)} />
            <button className='Rsvpexplorer_portaladdnewguest' onClick={addrela}>
                {iconwrapper(ADD_ICON, ADDICON_CSS)}
            </button>
        </div>

        <div style={{ border: '1px solid rgb(221, 221, 221)', minHeight: 200, maxHeight: '100%', borderRadius: 5, width: 'calc( 100% - 20px )', margin: '0px 10px', placeSelf: 'center', padding: 5, display: 'flex', flexDirection: 'row', flexWrap: 'wrap', overflowY: 'auto', alignContent: 'start', backgroundColor:'#f4f5f6' }}>
            {addrelamodalguestrelas && addrelamodalguestrelas.map((item, index) => {
                return (
                    <div key={item + index} className='Rsvpexplorer_portaltag' style={{ padding: '5px 0px 5px 14px' }} >
                        <div style={{ display: 'flex', alignContent: 'center', textAlign: 'center', paddingRight: 6 }}>{item}</div>
                        <button
                            style={{ padding: '0px 5px', color: '#b21212', backgroundColor: 'transparent', margin: 0, outline: 'none', border: 'none', }}
                            onClick={() => { delrela(index) }}
                        >
                            {iconwrapper(CROSS_ICON, CROSSICON_CSS)}
                        </button>
                    </div>
                )
            })}
        </div>

        <button className='Rsvpexplorer_portalsave' onClick={() => { props.save(addrelamodalguestrelas) }} disabled={addrelasavingstate === 'SAVING'}>
            {{ // IDLE, SAVING, SUCCESS, FAILURE
                'IDLE': 'Save',
                'SAVING': 'Saving...',
                'SUCCESS': 'New Category Saved',
                'FAILURE': 'Error Occurred, please try again later.'
            }[addrelasavingstate]}
        </button>

    </div>

    const success_dom = addrelasavingstate === 'SUCCESS'
        ? <Success
            txt={'Category updated. Click to return.'}
            onClick={props.close} />
        : null

    return <div className='Rsvpexplorer_portal'>
        <div className='Rsvpexplorer_portaltitle'> Add New Relationship </div>
        {addrelasavingstate !== 'SUCCESS' ? general_dom : success_dom}
    </div>

}

export default memo(Addrelacontent)